import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { cn } from "~/core/generic/shadcn-utils";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";

type CommandbarShortcutIconProps = {
  icon: IconProp;
  highlight?: boolean;
};

export default function CommandbarShortcutIcon({
  icon,
  highlight,
}: CommandbarShortcutIconProps) {
  return (
    <FontAwesomeIcon
      className={cn(
        "text-light size-3 p-1 bg-sidebar transition-colors ease-linear duration-100",
        { "text-dark bg-light": highlight },
      )}
      icon={icon}
    />
  );
}
